import { useState } from 'react'

import { Logo } from '../components/Logo'
import { Notice } from '../components/ui'
import { useAuth } from '../lib/auth'

export function Login() {
  const { signIn } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const submit = async (event: React.FormEvent) => {
    event.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await signIn(email.trim(), password)
    } catch (caught) {
      // The API returns the same message for an unknown account and a wrong
      // password. Pass it through rather than elaborating — guessing here would
      // turn the console into an account-enumeration oracle.
      setError(caught instanceof Error ? caught.message : String(caught))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="login">
      <form className="login__card stack" onSubmit={submit}>
        <div className="stack" style={{ gap: 6, alignItems: 'flex-start' }}>
          <Logo height={34} />
          <div className="dim" style={{ fontSize: 11.5 }}>
            Admin console
          </div>
        </div>

        <div className="field">
          <label className="field__label" htmlFor="email">
            Email
          </label>
          <input
            id="email"
            className="input"
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </div>

        <div className="field">
          <label className="field__label" htmlFor="password">
            Password
          </label>
          <input
            id="password"
            className="input"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </div>

        {error && <Notice tone="warn">{error}</Notice>}

        <button className="btn btn--primary" type="submit" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>

        <p className="dim" style={{ fontSize: 11, margin: 0 }}>
          Sessions live in this tab only. Closing it signs you out — an open console on an
          unattended machine is an unattended medical record.
        </p>
      </form>
    </div>
  )
}
